import { useEffect, useState } from 'react';
import { api, apiSecure } from '../axios.service';
import { UserSave } from '../../types/request/saveUser.model'
import { ResponseApi } from '../../types/response/responseapi.model';
import { Role } from '../../types/response/role.model';
import { ResponseUser } from '../../types/response/responseuser.model';

export function useSaveUser(userSave : UserSave | null | undefined){
    const [data, setData] = useState<ResponseApi>();
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<any>(null);

    useEffect(() => {
    
        if (userSave) {
        setIsLoading(true);
        api.post<UserSave>("/setUser", userSave)
            .then(res => setData(res.data as ResponseApi))
            .catch(err => {setError(err)})
            .finally(() => setIsLoading(false));
        }
    }, [userSave]);

    return {data, isLoading, error };
}

export function useGetRoles(){
    const [dataRole, setData] = useState<Role[]>();
    const [isLoadingRole, setIsLoading] = useState(false);
    const [errorRole, setError] = useState<any>(null);

    useEffect(() => {
        setIsLoading(true);
        apiSecure.post<Role[]>("/getroles", {username: localStorage.getItem("username")})
            .then(res => setData(res.data as Role[]))
            .catch(err => {setError(err)})
            .finally(() => setIsLoading(false));
    }, []);

    return {dataRole, isLoadingRole, errorRole };
}

export function useGetUsers(){
    const [dataUser, setData] = useState<ResponseUser[]>();
    const [isLoadingUser, setIsLoading] = useState(false);
    const [errorUser, setError] = useState<any>(null);

    useEffect(() => {
        setIsLoading(true);
        apiSecure.get<ResponseUser[]>("/admin/getAllUsers")
            .then(res => setData(res.data as ResponseUser[]))
            .catch(err => {setError(err)})
            .finally(() => setIsLoading(false));
    }, []);

    return {dataUser, isLoadingUser, errorUser };
}

export function useSetAdmin(idRequest: number | undefined){
    const [dataAdmin, setData] = useState<ResponseApi | null>(null);
    const [isLoadingAdmin, setIsLoading] = useState(false);
    const [errorAdmin, setError] = useState<any>(null);
    
    useEffect(() => {
        if(idRequest){        
            setIsLoading(true);
            apiSecure.post<ResponseApi>("/admin/setadmin", {id : idRequest})
                .then(res => setData(res.data as ResponseApi))
                .catch(err => {setError(err)})
                .finally(() => setIsLoading(false));
        }
    }, [idRequest]);

    return {dataAdmin, isLoadingAdmin, errorAdmin };
}

export function useSetGarde(idRequest: number | undefined){
    const [dataGarde, setData] = useState<ResponseApi | null>(null);
    const [isLoadingGarde, setIsLoading] = useState(false);
    const [errorGarde, setError] = useState<any>(null);
    
    useEffect(() => {
        if(idRequest){        
            setIsLoading(true);
            apiSecure.post<ResponseApi>("/admin/setgarde", {id : idRequest})
                .then(res => setData(res.data as ResponseApi))
                .catch(err => {setError(err)})
                .finally(() => setIsLoading(false));
        }
    }, [idRequest]);

    return {dataGarde, isLoadingGarde, errorGarde };
}

export function useBlockUser(idRequest: number | undefined){
    const [dataBlockUser, setData] = useState<ResponseApi | null>(null);
    const [isLoadingBlockUser, setIsLoading] = useState(false);
    const [errorBlockUser, setError] = useState<any>(null);

    useEffect(() => {
        if(idRequest){        
            setIsLoading(true);
            apiSecure.post<ResponseApi>("/admin/blockUser", {id : idRequest})
                .then(res => setData(res.data as ResponseApi))
                .catch(err => {setError(err)})
                .finally(() => setIsLoading(false));
        }
    }, [idRequest]);

    return {dataBlockUser, isLoadingBlockUser, errorBlockUser };
}

export function useAdminDeleteUser(idRequest: number | undefined){
    const [dataSupprUser, setData] = useState<ResponseApi | null>(null);
    const [isLoadingSupprUser, setIsLoading] = useState(false);
    const [errorSupprUser, setError] = useState<any>(null);

    useEffect(() => {
        if(idRequest){        
            setIsLoading(true);
            apiSecure.post<ResponseApi>("/admin/deleteuserbyid", {id : idRequest})
                .then(res => setData(res.data as ResponseApi))
                .catch(err => {setError(err)})
                .finally(() => setIsLoading(false));
        }
    }, [idRequest]);

    return {dataSupprUser, isLoadingSupprUser, errorSupprUser };
}